export default __webpack_public_path__ + "/assets/bg-formazione-02.jpg";